import { render, staticRenderFns } from "./alink-pop.vue?vue&type=template&id=504100e2&scoped=true&"
import script from "./alink-pop.vue?vue&type=script&lang=js&"
export * from "./alink-pop.vue?vue&type=script&lang=js&"
import style0 from "./alink-pop.vue?vue&type=style&index=0&id=504100e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504100e2",
  null
  
)

export default component.exports